<template>
  <v-container fluid fill-height align-start pa-0 class="pa-5">
    <div>현장명 : <input type="text" v-model="editingData.constructNm" @change="updateEditingData('constructNm', $event)" /></div>
    <div>업체명 : <input type="text" v-model="editingData.clntNm" @change="updateEditingData('clntNm', $event)" /></div>
    <VueDocumentEditor ref="vueDocumentEditor" :components="components" />
    <!-- <v-tabs active-class="active_tab" class="mt-3" v-model="tab">
      <v-tab class="px-2" v-for="item in tabs" :key="item.tabpageId" @click="clickTab(item.tabpageId)">{{ item.title }}</v-tab>
      <v-tabs-items v-model="tab" :touchless="true">
        <v-tab-item>
          <VueDocumentEditor ref="vueDocumentEditor" />
        </v-tab-item>
        <v-tab-item>
          <Tiptap ref="tiptap" />
        </v-tab-item>
        <v-tab-item>
          <GrapesJS ref="grapesJS" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs> -->
  </v-container>
  <!-- <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="작업계획서 양식 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <v-autocomplete
            v-model="selectedVersion"
            style="width: 300px"
            class="editor_bg ml-8"
            item-text="versionNm"
            item-value="versionId"
            :menu-props="{ offsetY: true }"
            :items="versionList"
            placeholder="양식 버전 선택"
            flat
            solo
            @change="versionChange($event)"
          />
          <v-autocomplete
            v-model="selectedSection"
            style="width: 300px"
            class="editor_bg ml-8"
            item-text="sectionNm"
            item-value="sectionId"
            :menu-props="{ offsetY: true }"
            :items="sectionList"
            placeholder="섹션 선택"
            flat
            solo
            @change="sectionChange($event)"
          />
        </template>
        <template v-slot:body>
          <v-tabs active-class="active_tab" class="mt-3" v-model="tab">
            <v-tab class="px-2" v-for="item in tabs" :key="item.tabpageId" @click="clickTab(item.tabpageId)">{{ item.title }}</v-tab>
            <v-tabs-items v-model="tab" :touchless="true">
              <v-tab-item>
                <Tiptap ref="tiptap" />
              </v-tab-item>
              <v-tab-item>
                <GrapesJS ref="grapesJS" />
              </v-tab-item>
              <v-tab-item>
                <VueDocumentEditor ref="vueDocumentEditor" />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnAdd="btnAdd()" @btnSearch="btnSearch()" @btnSave="btnSave()" @btnDelete="btnDelete()">
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container> -->
</template>

<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'

import EditorForm from '@/views/setting/editor/vueDocumentEditor/EditorForm.vue'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  components: {
    'i-card-right': iCardRight,
    'i-card-vertical': iCardVertical,
    VueDocumentEditor,
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      selectedVersion: '',
      selectedSection: '',
      tabs: [{ tabpageId: 'vueDocumentEditor', title: 'Vue-Document-Editor' }],
      tab: '', // 기존, 신규 탭 구분변수
      selectedTab: 'vueDocumentEditor', // 기존, 신규 탭 구분변수
      versionList: [],
      sectionList: [],
      components: [{ template: EditorForm, props: {} }],
    }
  },
  computed: {
    editingData() {
      return this.$store.state.workPlan.editingData
    },
  },
  beforeMount() {},
  mounted() {
    this.btnSearch()
  },
  beforeDestroy() {},
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    // 조회
    //------------------------------------------
    async btnSearch() {},
    //------------------------------------------
    // 현장명 업데이트
    //------------------------------------------
    updateEditingData(fieldCd, event) {
      const value = event.target.value
      this.$store.dispatch('workPlan/setEditingData', { key: fieldCd, value: value })
    },
    //------------------------------------------
    //  추가
    //------------------------------------------
    btnAdd() {},
    //------------------------------------------
    // 저장
    //------------------------------------------
    async btnSave() {},
    //------------------------------------------
    // 삭제
    //------------------------------------------
    async btnDelete() {},
    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////

    async versionChange(versionId) {
      if (!versionId) {
        this.selectedSection = ''
        this.sectionList = []
        if (this.editor) {
          this.editor.setComponents('')
        }
        return
      }

      try {
        // TODO: 선택한 버전의 섹션 목록 조회
        // const response = await this.$api.get(`/api/work-plan-form/${versionId}/sections`)
        // this.sectionList = response.data
        this.sectionList = []
      } catch (error) {
        console.error('섹션 목록 조회 오류:', error)
        this.$toast.error('섹션 목록 조회 중 오류가 발생했습니다.')
      }
    },
    async sectionChange(sectionId) {},
    async clickTab(id) {
      if (this.selectedTab === id) return
      this.selectedTab = id
    },
  },
}
</script>

<style scoped>
</style>
